import Vue from 'vue'
import Router from 'vue-router'
import config from '../../config/index.js'
import utils from '../utils';
import routerAuthor from './routerAuthor.js';
import store from '../store/index.js';

Vue.use(Router)

const test = resolve => require(['@/views/test/Test.vue'], resolve)
const testEditor = resolve => require(['@/views/test/testEditor.vue'], resolve)
const Html2Canvas = resolve => require(['@/views/test/Html2Canvas.vue'], resolve)

//
const error = resolve => require(['@/views/error/Error.vue'], resolve)
const index = resolve => require(['@/views/Index.vue'], resolve)
const login = resolve => require(['@/views/login/Login.vue'], resolve)
const main = resolve => require(['@/views/main/Main.vue'], resolve)
const loading = resolve => require(['@/components/Loading.vue'], resolve)
const managementCenterin = resolve => require(['@/views/managementCenterin/ManagementCenterin.vue'], resolve)
const manageApplication = resolve => require(['@/views/managementCenterin/ManageApplication.vue'], resolve)
const manageVersion = resolve => require(['@/views/managementCenterin/ManageVersion.vue'], resolve)
const manageRole = resolve => require(['@/views/managementCenterin/ManageRole.vue'], resolve)
const applicationCenter = resolve => require(['@/views/applicationCenter/ApplicationCenter.vue'], resolve)
const applicationNotice = resolve => require(['@/views/applicationCenter/ApplicationNotice.vue'], resolve)
const applicationPunch = resolve => require(['@/views/applicationCenter/ApplicationPunch.vue'], resolve)
const library = resolve => require(['@/views/applicationCenter/Library.vue'], resolve)
const workReport = resolve => require(['@/views/applicationCenter/workReport.vue'], resolve)

const applicationApproval = resolve => require(['@/views/applicationCenter/applicationApproval/ApplicationApproval.vue'], resolve)
const applicationWorkbench = resolve => require(['@/views/applicationCenter/applicationApproval/ApplicationWorkbench.vue'], resolve)
const applicationFormManage = resolve => require(['@/views/applicationCenter/applicationApproval/ApplicationFormManage.vue'], resolve)
const applicationFormTemplate = resolve => require(['@/views/applicationCenter/applicationApproval/ApplicationFormTemplate.vue'], resolve)
const applicationProcessManage = resolve => require(['@/views/applicationCenter/applicationApproval/ApplicationProcessManage.vue'], resolve)
const applicationRecList = resolve => require(['@/views/applicationCenter/applicationApproval/ApplicationRecList.vue'], resolve)
const expenseReimburs = resolve => require(['@/views/applicationCenter/applicationApproval/ExpenseReimburs.vue'], resolve)
const applyForm = resolve => require(['@/views/applicationCenter/applicationApproval/applicationWorkbench/initiatingApply/ApplyForm.vue'], resolve)
const newApplyForm = resolve => require(['@/views/applicationCenter/applicationApproval/applicationWorkbench/initiatingApply/NewApplyForm.vue'], resolve)
const copyMeForm = resolve => require(['@/views/applicationCenter/applicationApproval/applicationWorkbench/copyMe/CopyMeForm.vue'], resolve)
const copyMeFormNew = resolve => require(['@/views/applicationCenter/applicationApproval/applicationWorkbench/copyMe/CopyMeFormNew.vue'], resolve)
const costBasis = resolve => require(['@/views/applicationCenter/applicationApproval/applicationCose/CostBasis.vue'], resolve)
const designForm = resolve => require(['@/views/applicationCenter/applicationApproval/designForm/DesignForm.vue'], resolve)
const designProcess = resolve => require(['@/views/applicationCenter/applicationApproval/designProcess/DesignProcess.vue'], resolve)

const applicationAll = resolve => require(['@/views/applicationCenter/ApplicationAll.vue'], resolve)
const applicationFn = resolve => require(['@/views/applicationCenter/ApplicationFn.vue'], resolve)
const applicationRecord = resolve => require(['@/views/applicationCenter/ApplicationRecord.vue'], resolve)
const applicationManagement = resolve => require(['@/views/applicationCenter/ApplicationManagement.vue'], resolve)
const applicationDetailTwo = resolve => require(['@/views/applicationCenter/ApplicationDetailTwo.vue'], resolve)

const addressList = resolve => require(['@/views/addressList/AddressList.vue'], resolve)
const addressMain = resolve => require(['@/views/addressList/AddressMain.vue'], resolve)
const viewDeptStaff = resolve => require(['@/views/addressList/ViewDeptStaff.vue'], resolve)
const memberDetail = resolve => require(['@/views/addressList/MemberDetail.vue'], resolve)
const CreateMember = resolve => require(['@/views/addressList/CreateMember.vue'], resolve)
const roleManage = resolve => require(['@/views/addressList/RoleManage.vue'], resolve)


const attendanceGroup = resolve => require(['@/views/applicationCenter/applicationApproval/AttendanceGroup.vue'], resolve);
const attendGroupAdd = resolve => require(['@/views/applicationCenter/applicationApproval/attendGroup/AttendGroupAdd.vue'], resolve);
const monthlyStatist = resolve => require(['@/views/applicationCenter/applicationApproval/MonthlyStatist.vue'], resolve);
const dailyStatist = resolve => require(['@/views/applicationCenter/applicationApproval/DailyStatist.vue'], resolve);
const punchTime = resolve => require(['@/views/applicationCenter/applicationApproval/PunchTime.vue'], resolve);
const originalRecord = resolve => require(['@/views/applicationCenter/applicationApproval/OriginalRecord.vue'], resolve);

const writeReport = resolve => require(['@/views/applicationCenter/applicationApproval/WriteReport.vue'], resolve);
const reportSuccess = resolve => require(['@/views/applicationCenter/applicationApproval/ReportSuccess.vue'], resolve);
const lookReport = resolve => require(['@/views/applicationCenter/applicationApproval/LookReport.vue'], resolve);
const submitReport = resolve => require(['@/views/applicationCenter/applicationApproval/SubmitReport.vue'], resolve);
const reportDetail = resolve => require(['@/views/applicationCenter/applicationApproval/ReportDetail.vue'], resolve);


// 公告详情
const noticeDetail = resolve => require(['@/views/h5/NoticeDetail.vue'], resolve)
//下载页
const downlaodPage = resolve => require(['@/views/h5/Download.vue'], resolve)
const txt = resolve => require(['@/views/h5/txt.vue'], resolve)

const loginCheck = utils.getCookie('loginCheck');

//消息
const messageCenter = resolve => require(['@/views/messageCenter/index.vue'], resolve)
const IntraWarNews = resolve => require(['@/views/messageCenter/IntraWarNews.vue'], resolve)
const empty = resolve => require(['@/views/messageCenter/iNsComponent/empty.vue'], resolve)
const projChange = resolve => require(['@/views/messageCenter/iNsComponent/projChange.vue'], resolve)
const projJournal = resolve => require(['@/views/messageCenter/iNsComponent/projJournal.vue'], resolve)
const changed = resolve => require(['@/views/messageCenter/iNsComponent/changed.vue'], resolve)
const projControl = resolve => require(['@/views/messageCenter/iNsComponent/projControl.vue'], resolve)
const acceptanceInfo = resolve => require(['@/views/messageCenter/iNsComponent/acceptance.vue'], resolve)
const settlementInfo = resolve => require(['@/views/messageCenter/iNsComponent/settlement.vue'], resolve)
const last = resolve => require(['@/views/messageCenter/iNsComponent/last.vue'], resolve)
const budgetApprovalInfo = resolve => require(['@/views/messageCenter/iNsComponent/budgetApproval.vue'], resolve)
const cxccBidStatusInfo = resolve => require(['@/views/messageCenter/iNsComponent/cxccBidStatusInfo.vue'], resolve)
const nomal = resolve => require(['@/views/messageCenter/iNsComponent/nomal.vue'], resolve)
const confirmReceipt = resolve => require(['@/views/messageCenter/iNsComponent/confirmReceipt.vue'], resolve)
const projectApproval = resolve => require(['@/views/messageCenter/iNsComponent/projectApproval.vue'], resolve)
const winningTheBid = resolve => require(['@/views/messageCenter/iNsComponent/winningTheBid.vue'], resolve)
const tenderPreparation = resolve => require(['@/views/messageCenter/iNsComponent/tenderPreparation.vue'], resolve)
const businessOpportunity = resolve => require(['@/views/messageCenter/iNsComponent/businessOpportunity.vue'], resolve)
const submitOpportunity = resolve => require(['@/views/messageCenter/iNsComponent/submitOpportunity.vue'], resolve)
const followUpOpportunity = resolve => require(['@/views/messageCenter/iNsComponent/followUpOpportunity.vue'], resolve)

const setMessage = resolve => require(['@/views/messageCenter/setMessage.vue'], resolve)

//BMS
const bmsPart = resolve => require(['@/views/applicationCenter/bmsPart.vue'], resolve)
const bmsProject = resolve => require(['@/views/applicationCenter/applicationApproval/bmsProject.vue'], resolve)
const busiOppoStatus = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/busiOppoStatus.vue'], resolve)
const busiOppoStatusView = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/busiOppoStatusView.vue'], resolve)

const busiOppoItemStatus = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/busiOppoItemStatus.vue'], resolve)
const busiOppoItemStatusView = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/busiOppoItemStatusView.vue'], resolve)

const projModeStatus = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/projModeStatus.vue'], resolve)
const bidPrepareStatus = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/bidPrepareStatus.vue'], resolve)
const bidPrepareStatusView = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/bidPrepareStatusView.vue'], resolve)
const winbidStatus = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/winbidStatus.vue'], resolve)
const winbidStatusView = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/winbidStatusView.vue'], resolve)
const projItemStatus = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/projItemStatus.vue'], resolve)
const projItemStatusView = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/projItemStatusView.vue'], resolve)
const cxccBidStatus = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/cxccBidStatus.vue'], resolve)
const cxccBidStatusView = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/cxccBidStatusView.vue'], resolve)
const projectBudgetApproval = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/projectBudgetApproval.vue'], resolve)
const projectBudgetApprovalDetail = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/projectBudgetApprovalDetail.vue'], resolve)
const signContract = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/signContract.vue'], resolve)
const signContractDetail = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/signContractDetail.vue'], resolve)
const projectControl = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/projectControl.vue'], resolve)
const projectControlDetail = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/projectControlDetail.vue'], resolve)
const projectAcceptance = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/projectAcceptance.vue'], resolve)
const projectAcceptanceDetail = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/projectAcceptanceDetail.vue'], resolve)
const settlement = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/settlement.vue'], resolve)
const settlementDetail = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/settlementDetail.vue'], resolve)
const projectFiles = resolve => require(['@/views/applicationCenter/applicationApproval/technologicalProcess/projectFiles.vue'], resolve)

const budgetApproval = resolve => require(['@/views/applicationCenter/applicationApproval/budgetApproval.vue'], resolve)
const budgetApprovalDetail = resolve => require(['@/views/applicationCenter/applicationApproval/budgetComponents/detail.vue'], resolve)
const budgetApprovalEdit = resolve => require(['@/views/applicationCenter/applicationApproval/budgetComponents/edit.vue'], resolve)
const permissionSetting = resolve => require(['@/views/applicationCenter/applicationApproval/permissionSetting.vue'], resolve)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index,
    redirect: { name: utils.getCookie("userToken") ? "main" : "login" },
    children: [
      {
        path: '/error',
        name: 'error',
        component: error
      },
      {
        path: '/test',
        name: 'test',
        component: test
      },
      {
        path: '/Html2Canvas',
        name: 'Html2Canvas',
        component: Html2Canvas
      },
      {
        path: '/testEditor',
        name: 'testEditor',
        component: testEditor
      },
      {
        path: '/login',
        name: 'login',
        component: login
      },
      {
        path: '/main',
        name: 'main',
        component: main
      },
      {
        path: '/managementCenterin',
        name: 'managementCenterin',
        component: managementCenterin,
        redirect: to => {
          return localStorage.authorId && localStorage.authorId != '' && localStorage.authorId.split(",").indexOf('QXGL') != -1 ? { name: "manageRole" } : (localStorage.authorId && localStorage.authorId != '' && localStorage.authorId.split(",").indexOf('YYGL') != -1 ? { name: "manageApplication" } : { name: "manageVersion" });
        },
        children: [
          {
            path: 'manageRole',
            name: 'manageRole',
            component: manageRole,
          },
          {
            path: 'manageApplication',
            name: 'manageApplication',
            component: manageApplication,
          },
          {
            path: 'manageVersion',
            name: 'manageVersion',
            component: manageVersion,
          }
        ]
      },
      {
        path: '/messageCenter',
        name: 'messageCenter',
        component: messageCenter,
        redirect: { name: "IntraWarNews" },
        children: [
          {
            path: 'IntraWarNews', // 站内消息
            name: 'IntraWarNews',
            component: IntraWarNews,
            children: [
              {
                path: 'empty', // 没有文件
                name: 'empty',
                component: empty,
              },
              {
                path: 'changed', // 变更了
                name: 'changed',
                component: changed,
              },
              {
                path: 'projJournal', // 项目日志
                name: 'projJournal',
                component: projJournal,
              },
              {
                path: 'projChange', // 项目变更 
                name: 'projChange',
                component: projChange,
              },
              {
                path: 'projControl', // 项目管控
                name: 'projControl',
                component: projControl,
              },
              {
                path: 'acceptanceInfo', // 项目验收
                name: 'acceptanceInfo',
                component: acceptanceInfo,
              },
              {
                path: 'last', // 终止暂停
                name: 'last',
                component: last,
              },
              {
                path: 'settlementInfo', // 终止暂停
                name: 'settlementInfo',
                component: settlementInfo,
              },
              {
                path: 'budgetApprovalInfo', // 预算审批
                name: 'budgetApprovalInfo',
                component: budgetApprovalInfo,
              },
              {
                path: 'nomal', // 填写类消息
                name: 'nomal',
                component: nomal,
              },
              {
                path: 'cxccBidStatusInfo', // 配合运营商投标消息
                name: 'cxccBidStatusInfo',
                component: cxccBidStatusInfo,
              },
              {
                path: 'confirmReceipt', // 确认收货
                name: 'confirmReceipt',
                component: confirmReceipt,
              },
              {
                path: 'projectApproval', // 确认收货
                name: 'projectApproval',
                component: projectApproval,
              },
              {
                path: 'winningTheBid', // 中标信息
                name: 'winningTheBid',
                component: winningTheBid,
              },
              {
                path: 'tenderPreparation', // 投标准备
                name: 'tenderPreparation',
                component: tenderPreparation,
              },
              {
                path: 'businessOpportunity', // 商机立项
                name: 'businessOpportunity',
                component: businessOpportunity,
              },
              {
                path: 'submitOpportunity', // 提交了商机
                name: 'submitOpportunity',
                component: submitOpportunity,
              },
              {
                path: 'followUpOpportunity', // 商机跟进
                name: 'followUpOpportunity',
                component: followUpOpportunity,
              },
            ]
          },
          {
            path: 'setMessage', // 消息设置
            name: 'setMessage',
            component: setMessage,
          },
        ]
      },
      {
        path: '/applicationCenter',
        name: 'applicationCenter',
        component: applicationCenter,
        redirect: { name: "applicationApproval" },
        children: [
          {
            path: 'applicationNotice',
            name: 'applicationNotice',
            redirect: { name: "applicationAll" },
            component: applicationNotice,
            children: [
              {
                path: 'applicationAll',
                name: 'applicationAll',
                component: applicationAll,
              },
              {
                path: 'applicationFn',
                name: 'applicationFn',
                component: applicationFn,
              },
              {
                path: 'applicationRecord',
                name: 'applicationRecord',
                component: applicationRecord,
              },
              {
                path: 'applicationManagement',
                name: 'applicationManagement',
                component: applicationManagement,
              },
              {
                path: 'applicationDetailTwo',
                name: 'applicationDetailTwo',
                component: applicationDetailTwo,
              }
            ]
          },
          {
            path: 'applicationApproval', // 审批
            name: 'applicationApproval',
            component: applicationApproval,
            redirect: { name: "applicationWorkbench" },
            children: [
              {
                path: 'applicationWorkbench', // 工作台
                name: 'applicationWorkbench',
                component: applicationWorkbench,
                meta: { keepAlive: true }
              },
              {
                path: 'applicationFormManage', // 表单管理
                name: 'applicationFormManage',
                component: applicationFormManage,
              },
              {
                path: 'applicationRecList', // 申请记录
                name: 'applicationRecList',
                component: applicationRecList,
                meta: { keepAlive: true }
              },
              {
                path: 'expenseReimburs', // 费用报销单- 基础设置
                name: 'expenseReimburs',
                component: expenseReimburs,
                redirect: { name: 'costBasis' },
                children: [
                  {
                    path: 'costBasis',
                    name: 'costBasis',
                    component: costBasis,
                    meta: { keepAlive: true }
                  },
                  {
                    path: 'designForm',
                    name: 'designForm',
                    component: designForm,
                    meta: { keepAlive: true }
                  },
                  {
                    path: 'designProcess',
                    name: 'designProcess',
                    component: designProcess,
                    meta: { keepAlive: true }
                  }

                ]
              },
              {
                path: 'applicationFormTemplate', // 表单模板
                name: 'applicationFormTemplate',
                component: applicationFormTemplate,
              },
              {
                path: 'applicationProcessManage', // 流程管理
                name: 'applicationProcessManage',
                component: applicationProcessManage,
              },
              {
                path: 'newApplyForm', // 重新提交表单申请
                name: 'newApplyForm',
                component: newApplyForm,
                meta: { keepAlive: true }
              },
              {
                path: 'applyForm', // 表单申请
                name: 'applyForm',
                component: applyForm,
                meta: { keepAlive: true }
              },
              {
                path: 'copyMeForm', // 表单申请
                name: 'copyMeForm',
                component: copyMeForm,
                meta: { keepAlive: true }
              },
              {
                path: 'copyMeFormNew', // 表单申请拷贝
                name: 'copyMeFormNew',
                component: copyMeFormNew,
                meta: { keepAlive: true }
              },
            ]
          },
          {
            path: 'applicationPunch', // 考勤打卡
            name: 'applicationPunch',
            component: applicationPunch,
            redirect: to => {
              if (localStorage.authorId && localStorage.authorId != '' && localStorage.authorId.split(",").indexOf('KQZSZ') != -1) {
                return { name: "attendanceGroup" }
              } else if (localStorage.authorId && localStorage.authorId != '' && localStorage.authorId.split(",").indexOf('YDTJ') != -1) {
                return { name: "monthlyStatist" }
              } else if (localStorage.authorId && localStorage.authorId != '' && localStorage.authorId.split(",").indexOf('MRTJ') != -1) {
                return { name: "dailyStatist" }
              } else if (localStorage.authorId && localStorage.authorId != '' && localStorage.authorId.split(",").indexOf('DKSJ') != -1) {
                return { name: "punchTime" }
              } else {
                return { name: "originalRecord" }
              }
            },
            children: [
              {
                path: 'attendanceGroup', // 考勤组设置
                name: 'attendanceGroup',
                component: attendanceGroup
              },
              {
                path: 'attendGroupAdd', // 新增考勤组
                name: 'attendGroupAdd',
                component: attendGroupAdd
              },
              {
                path: 'monthlyStatist', // 月度统计
                name: 'monthlyStatist',
                component: monthlyStatist
              },
              {
                path: 'dailyStatist', // 每日统计
                name: 'dailyStatist',
                component: dailyStatist
              },
              {
                path: 'punchTime', // 打卡时间
                name: 'punchTime',
                component: punchTime
              },
              {
                path: 'originalRecord', // 原始记录
                name: 'originalRecord',
                component: originalRecord
              },
            ]
          },
          {
            path: 'library', // 文库
            name: 'library',
            component: library,
          },
          {
            path: 'workReport', // 工作汇报
            name: 'workReport',
            component: workReport,
            redirect: { name: "lookReport" },
            children: [
              {
                path: 'writeReport', // 写汇报
                name: 'writeReport',
                component: writeReport
              },
              {
                path: 'lookReport', // 看汇报
                name: 'lookReport',
                component: lookReport
              },
              {
                path: 'submitReport', // 已提交
                name: 'submitReport',
                component: submitReport
              },
              {
                path: 'reportDetail', // 汇报详情
                name: 'reportDetail',
                component: reportDetail
              },
              {
                path: 'reportSuccess',
                name: 'reportSuccess',
                component: reportSuccess
              }
            ]
          },
          {
            path: 'bmsPart', // BMS
            name: 'bmsPart',
            component: bmsPart,
            redirect: { name: "bmsProject" },
            children: [
              {
                path: 'bmsProject', // 项目
                name: 'bmsProject',
                component: bmsProject
              },
              {
                path: 'busiOppoStatus', // 商机
                name: 'busiOppoStatus',
                component: busiOppoStatus,
              },
              {
                path: 'busiOppoStatusView', // 商机查看
                name: 'busiOppoStatusView',
                component: busiOppoStatusView,
              },
              {
                path: 'busiOppoItemStatus', // 商机立项
                name: 'busiOppoItemStatus',
                component: busiOppoItemStatus,
              },
              {
                path: 'busiOppoItemStatusView', // 商机立项查看
                name: 'busiOppoItemStatusView',
                component: busiOppoItemStatusView,
              },
              {
                path: 'projModeStatus', // 模式选择
                name: 'projModeStatus',
                component: projModeStatus,
              },
              {
                path: 'bidPrepareStatus', // 投标准备
                name: 'bidPrepareStatus',
                component: bidPrepareStatus
              },
              {
                path: 'bidPrepareStatusView', // 投标准备查看
                name: 'bidPrepareStatusView',
                component: bidPrepareStatusView
              },
              {
                path: 'winbidStatus', // 中标
                name: 'winbidStatus',
                component: winbidStatus
              },
              {
                path: 'winbidStatusView', // 中标查看
                name: 'winbidStatusView',
                component: winbidStatusView
              },
              {
                path: 'projItemStatus', // 项目立项
                name: 'projItemStatus',
                component: projItemStatus
              },
              {
                path: 'projItemStatusView', // 项目立项查看
                name: 'projItemStatusView',
                component: projItemStatusView
              },
              {
                path: 'cxccBidStatus', // 配合运营商投标
                name: 'cxccBidStatus',
                component: cxccBidStatus
              },
              {
                path: 'cxccBidStatusView', // 配合运营商投标查看
                name: 'cxccBidStatusView',
                component: cxccBidStatusView
              },
              {
                path:'projectBudgetApproval',//项目-预算审批
                name:'projectBudgetApproval',
                component:projectBudgetApproval
              },
              {
                path:'projectBudgetApprovalDetail',//查看预算审批
                name:'projectBudgetApprovalDetail',
                component:projectBudgetApprovalDetail
              },
              { 
                path: 'signContract', //签订合同
                name: 'signContract',
                component:signContract
              },
              { 
                path: 'signContractDetail', //查看签订合同
                name: 'signContractDetail',
                component:signContractDetail
              },
              {
                path:'projectControl',//项目管控
                name:'projectControl',
                component:projectControl,
              },
              {
                path:'projectControlDetail',//查看项目管控
                name:'projectControlDetail',
                component:projectControlDetail,
              },
              {
                path:'projectAcceptance',//项目验收
                name:'projectAcceptance',
                component:projectAcceptance, 
              },
              {
                path:'projectAcceptanceDetail',//查看项目验收
                name:'projectAcceptanceDetail',
                component:projectAcceptanceDetail, 
              },
              {
                path: 'settlement', // 结算
                name: 'settlement',
                component: settlement
              },
              {
                path:'settlementDetail',//查看结算
                name: 'settlementDetail',
                component: settlementDetail
              },
              {
                path:'projectFiles',//归档
                name: 'projectFiles',
                component: projectFiles
              },
              {
                path: 'budgetApproval', // 预算报批
                name: 'budgetApproval',
                component: budgetApproval
              },
              { 
                path: 'budgetApprovalDetail', //查看预算报批
                name: 'budgetApprovalDetail',
                component:budgetApprovalDetail
              },
              { 
                path: 'budgetApprovalEdit', //查看预算报批
                name: 'budgetApprovalEdit',
                component:budgetApprovalEdit
              },
              {
                path: 'bmsAuth', // 权限设置
                name: 'bmsAuth',
                component: permissionSetting
              }
            ]
          }
        ]
      },
      {
        path: '/addressList',
        name: 'addressList',
        component: addressList,
        redirect: "/addressMain",
        children: [
          {
            path: '/addressMain',
            name: 'addressMain',
            component: addressMain,
          },
          {
            path: '/viewDeptStaff',
            name: 'viewDeptStaff',
            component: viewDeptStaff,
          },
          {
            path: '/memberDetail',
            name: 'memberDetail',
            component: memberDetail,
          },
          {
            path: '/CreateMember',
            name: 'CreateMember',
            component: CreateMember,
          },
          {
            path: '/roleManage',
            name: 'roleManage',
            component: roleManage,
          }
        ]
      }]
  },
  {
    path: '/noticeDetail/:id',
    name: 'noticeDetail',
    component: noticeDetail
  }, {
    path: '/download',
    name: 'downlaodPage',
    component: downlaodPage
  },
  {
    path: '/loading',
    name: 'loading',
    component: loading
  },
  {
    path: '/txt',
    name: 'txt',
    component: txt
  },
]

const routeBase = process.env.NODE_ENV === 'production' ? config.build.assetsPublicPath : config.dev.assetsPublicPath;
const router = new Router({
  // base: routeBase,
  mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {//to目标，from来源
  if (to.name == 'downlaodPage') {
    next()
    return;
  }
  if (to.name == 'txt') {
    next()
    return;
  }
  if (to.name != 'login' && !utils.getCookie('userToken')) {
    utils.clearCookie('userToken');
    store.commit('CHANGE_IsShow', false);
    next({ path: '/login' })
    // window.location.reload()
    return;
  }
  let arr = []
  to.matched.forEach((el, index) => {
    if (index + 1 == to.matched.length) {
      if (Object.keys(to.query).length != 0 && to.query.id) {
        arr.push((el.name + Object.values(to.query)[0]).toString())
      } else {
        arr.push(el.name)
      }
    } else {
      arr.push(el.name)
    }
  })
  localStorage.route = arr.join(',')
  if(to.path.split('/').indexOf('IntraWarNews')>-1){
    next();
  }else if (localStorage.authorId && localStorage.authorId != '' && localStorage.authorId.split(',').indexOf(routerAuthor[to.name]) != -1) {
    next();
  } else {
    if (to.name == 'login' || !to.name || to.name == 'noticeDetail' || to.name == 'downlaodPage' || to.name == 'loading') {
      next()
    } else {
      utils.toast('您没有该页面的权限', 1000);
      // router.push({ name: 'main' })
      // router.go(-1);
      // next()
    }
  }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js